var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationdark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.25C12.9288 11.25 11.25 12.9288 11.25 15C11.25 17.0712 12.9288 18.75 15 18.75C17.0712 18.75 18.75 17.0712 18.75 15C18.75 12.9288 17.0712 11.25 15 11.25ZM15 21.25C11.5487 21.25 8.75 18.4525 8.75 15C8.75 11.5475 11.5487 8.75 15 8.75C18.4513 8.75 21.25 11.5475 21.25 15C21.25 18.4525 18.4513 21.25 15 21.25ZM15 0C6.71625 0 0 6.71625 0 15C0 21.2725 12.5063 40.0137 15 40C17.455 40.0137 30 21.1875 30 15C30 6.71625 23.2838 0 15 0Z",
    fill: "#0D263C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationdark);
export default __webpack_public_path__ + "static/media/locationdark.9cf54a4d612bda2f1bd4ac5087748a65.svg";
export { ForwardRef as ReactComponent };